import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { prepareSearchParams } from '@/libs/helper';

const resource = `${Config.basePath}/subscript`;

export default {
  index(payload) {
    return Client.get(`${resource}/payment/history`, {
      params: {
        ...prepareSearchParams(payload),
        limit: payload.perPage,
      },
    });
  },
  show() {
    return Client.get(`${resource}`);
  },
  planList() {
    return Client.get(`${resource}/plan/list`);
  },
  renew(payload) {
    return Client.post(`${resource}/renew`, payload);
  },
  cancel(payload = {}) {
    return Client.post(`${resource}/cancel`, payload);
  },
};
